import React from "react";
import { getListCardStyle } from "../listCardStyles";

const truncateDescription = (desc = "", limit = 200, isExpanded = false) => {
  if (isExpanded || desc.length <= limit) return desc;
  return `${desc.slice(0, limit)}…`;
};

const ListCard = ({
  item,
  layerLabel,
  isExpanded,
  onToggleDescription,
  onSelect,
  isMobile = false,
  translate = (key) => key,
  language = "en",
}) => {
  if (!item) return null;
  const canToggle = Boolean(item.DESCRIPTION && item.DESCRIPTION.length > 200);
  const hasWeb = Array.from(new Set(item.WEB_MULTI || [])).length > 0;
  const hasEmail = Array.from(new Set(item.EMAIL_MULTI || [])).length > 0;
  const hasPhone = Array.from(new Set(item.PHONE_MULTI || [])).length > 0;

  return (
    <div
      role="button"
      aria-label={item.NOM}
      tabIndex={0}
      onClick={() => {
        if (!isExpanded && canToggle) {
          onToggleDescription && onToggleDescription();
        } else if (onSelect) {
          onSelect();
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (!isExpanded && canToggle) {
            onToggleDescription && onToggleDescription();
          } else {
            onSelect && onSelect();
          }
        }
      }}
      className="dm-card"
      style={getListCardStyle({ isMobile })}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 10,
          alignItems: "flex-start",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: "#0f172a",
              lineHeight: 1.3,
            }}
          >
            {item.NOM}
          </div>
          {item.RESPONSABLES && item.RESPONSABLES !== item.NOM ? (
            <div style={{ color: "#6b7280", fontWeight: 600 }}>
              {item.RESPONSABLES}
            </div>
          ) : null}
        </div>
        {canToggle ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onToggleDescription && onToggleDescription();
            }}
            aria-label={isExpanded ? translate("showLess") : translate("showMore")}
            style={{
              border: "1px solid #e5e7eb",
              background: "#f8fafc",
              color: "#4b5563",
              fontWeight: 700,
              cursor: "pointer",
              padding: "4px 6px",
              borderRadius: 8,
              fontSize: 14,
              alignSelf: "flex-start",
              lineHeight: 1,
            }}
          >
            {isExpanded ? "×" : "▾"}
          </button>
        ) : null}
      </div>
      {item.taxonomies?.length ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          {item.taxonomies.map((tax) => (
            <span
              key={tax.code || tax.id}
              className="dm-chip"
              style={{
                background: tax.color || "#265b4f",
              }}
            >
              {pickLabel(tax, language)}
            </span>
          ))}
        </div>
      ) : null}

      {item.DESCRIPTION ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <div
            style={{
              color: "#688C82",
              lineHeight: 1.5,
              fontSize: 14,
            }}
          >
            {truncateDescription(item.DESCRIPTION, 200, isExpanded)}
          </div>
          {/* Button moved to header area */}
        </div>
      ) : null}

      {isExpanded ? (
        <>
          {(hasEmail || hasPhone || hasWeb) && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
                color: "#688C82",
                fontSize: 14,
              }}
            >
              {hasEmail
                ? Array.from(new Set(item.EMAIL_MULTI || [])).map((mail) => (
                    <div key={mail}>{mail}</div>
                  ))
                : null}
              {hasPhone
                ? Array.from(new Set(item.PHONE_MULTI || [])).map((p) => (
                    <div key={p}>{p}</div>
                  ))
                : null}
              {hasWeb
                ? Array.from(new Set(item.WEB_MULTI || [])).map((url) => (
                    <div key={url}>{url}</div>
                  ))
                : null}
            </div>
          )}
        </>
      ) : null}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          color: "#265B4F",
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span>
            {[item.ADRESS, item.CP, item.VILLE].filter(Boolean).join(" ")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ListCard;

const pickLabel = (obj = {}, language = "en") => {
  const order = [
    `label_${language}`,
    "label_en",
    "label_fr",
    "label_nl",
    "label",
  ];
  const val = order
    .map((k) => obj[k])
    .find((v) => typeof v === "string" && v.trim().length > 0);
  return val?.trim() || obj.code || obj.id || "";
};
